import { LocalizedTextDisplayModel } from '@/api/model-index';
import { I18nService } from '@/core/services/i18nService';
import { StateService } from '@/core/services/state.service';
import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';

@Component({
  selector: 'app-navigation-item',
  templateUrl: './navigation-item.component.html',
  styleUrls: ['./navigation-item.component.scss']
})
export class NavigationItemComponent implements OnInit {
  @Input() name: LocalizedTextDisplayModel[];
  @Input() href: string = "";
  @Input() isValid: boolean = false;
  @Input() isActive: boolean = false;
  @Input() isSubItem: boolean = false;
  @Input() showValidationStatus: boolean = true;

  public queryParams?: Params;

  public get showText(): boolean {
    return this.stateService.showProzessNavigation;
  }

  public get isAlreadyOnRoute(): boolean {
    //substring(2) weil href bei anfrage mit ./ anfangen und bei reports sogar mit ../
    return this.router.url.endsWith(this.href.substring(2));
  }

  constructor(protected stateService: StateService, protected route: ActivatedRoute, protected languageservice: I18nService, protected router: Router) { }

  ngOnInit(): void {
    this.queryParams = this.route.snapshot.queryParams;
  }

  public get GetLocalizedName(): string{
    return this.languageservice.getCurrentLocalizedTextDisplayModel(this.name)?.text ?? this.name.find(x => x.text != null)?.text ?? this.languageservice.instant('undefinedText');
  }
}
